import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import { isEmpty } from 'lodash'
import { TranslationContext } from 'contexts/TranslationContext'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from 'components/base/Button'
import { Box } from '@material-ui/core'
import { selectBatchImportFilesData } from '~/selectors/mainView'
import { ReactComponent as CloseIcon } from '~/assets/settings/navigation_close.svg'
import { abortBatchFileUploadTask } from '~/actions/sourceFiles'
import './ImportBatchFiles.scss'


export const ImportBatchFiles = () => {
  const { t } = React.useContext(TranslationContext)
  const dispatch = useDispatch()
  const { progress, visible,
    taskId, error, fileIds } = useSelector(selectBatchImportFilesData)
  const onCancel = useCallback(async () => {
    if (taskId) {
      await dispatch(abortBatchFileUploadTask(taskId, fileIds))
    }
  }, [ taskId, dispatch, fileIds ])

  useEffect(() => {
    window.addEventListener('beforeunload', onCancel)
    return () => {
      window.removeEventListener('beforeunload', onCancel)
    }
  }, [ onCancel ])

  return (
    <Dialog
      open={visible}
      fullWidth
      maxWidth="xs"
      disableRestoreFocus
      className={classNames('base-dialog import-batch-files')}
    >
      <DialogTitle className="import-batch-files__head">
        <Box>{t('BATCH_IMPORT_FILES_HEAD')}</Box>
        <div className="import-batch-files__close" onClick={onCancel}>
          <CloseIcon />
        </div>
      </DialogTitle>

      <DialogContent className="import-batch-files__content">
        <Box>
          <Box className="import-batch-files__progress-body">
            {/* <LinearProgress
              className="import-batch-files__progress"
              variant="determinate"
              value={100}
            /> */}
            <div className="import-batch-files__loader">
              <div className="import-batch-files__loader-inner" style={{ width: `${Math.min(progress, 100)}%` }} />
            </div>
          </Box>
          <Button
            border
            onClick={onCancel}
            variant="outlined"
            className="import-batch-files__cancel btn"
          >
            {t('CONFIRMATION_DIALOG_BTN_CANCEL')}
          </Button>
        </Box>
        <Box className="import-batch-files__status">{!isEmpty(error) ? `Error: ${error}` : `${t('BATCH_IMPORT_FILES_PROGRESS_TEXT')}...`}</Box>
      </DialogContent>
    </Dialog>
  )
}
